import React, { useEffect, useContext, useState } from "react";
import Footer from "../components/footer";
import { listOrganizationalUnits } from "../services/api_org_unit";
import { AuthContext } from "../contexts/auth";
import ComboboxAutocomplete from "../components/combobox_autocomplete";
import Fetching from "../components/fetching";
import CheckPermissions from "../components/check_permissions";
import { Link } from "wouter";
import CustomDatePicker from "../components/custom_date_picker";
import CollapsibleTable from "../components/collapsible_table";
import moment from "moment";
import PopoverComponentCustom from "../components/popover_component";

  
function Statistics() {
    const { token, profile } = useContext(AuthContext);
    const [selectedUnitId, setSelectedUnitId] = useState(null);
    const [units, setUnits] = useState([]);
    const [unitData, setUnitData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const isProfileComplete = profile.has_complete_profile;

    const selectedUnit = units.find(u => u.id === selectedUnitId)

    useEffect(() => {
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');

        setStartDate(startOfMonth);
        setEndDate(endOfMonth);
    }, []);



    useEffect(() => {
        setIsLoading(true);
        setIsError(false);

        listOrganizationalUnits(token, true, null, 'shifts').then((data) => {
            setUnits(data.data || []);
            setIsLoading(false);
        }).catch(error => {
            console.error('Error fetching units:', error);
            {(error.response.status !== 402) &&
                setIsError(true);
                setIsLoading(false);
            }
        });
    }, [token]);

    const handleParentChange = (selectedParent) => {
        if (selectedParent) {
            const newParentId = selectedParent.id;
            setSelectedUnitId(newParentId);
        } else {
            setSelectedUnitId(null);
            setUnitData(null);
        }
    };

    const handleResetUnitSelection = () => {
        setSelectedUnitId(null);
    };

    const handleDateChange = (newStartDate, newEndDate) => {
        const formattedStartDate = newStartDate ? moment(newStartDate).format("YYYY-MM-DD") : null;
        const formattedEndDate = newEndDate ? moment(newEndDate).format("YYYY-MM-DD") : null;
    
        setStartDate(formattedStartDate);
        setEndDate(formattedEndDate);
    };

    if (isLoading) return <Fetching />
    if (isError) return <div>Error loading data</div>;

    return (
        <div className="min-h-full">
            <PopoverComponentCustom title='Statistiche' />
            {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                        <p className="text-center text-sm font-semibold">
                            Il profilo non è completo. <br />
                            Compila i campi mancanti{' '}
                            <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                            >
                            cliccando qui
                            </Link>
                        </p>
                    </div>
                </div>
            )}
            <main className="mt-10 pb-8">
                <div className="grid md:grid-cols-4 grid-cols-1 items-center mx-5 gap-y-4 md:gap-y-0 md:gap-x-4 mb-4">
                    <div className="md:hidden block col-span-1 mb-3">
                    </div>
                    <div className="col-span-1 justify-end">
                        <p className='mr-5 flex lg:justify-end justify-start font-medium text-gray-700 mb-4 md:mb-0 uppercase text-sm'>Unità Organizzativa</p>
                    </div>
                    <div className="col-span-1 justify-end ml-2">
                        <ComboboxAutocomplete
                            options={units}
                            bgActiveColor="bg-indigo-100"
                            textActiveColor="text-gray-700"
                            placeholder="Seleziona Unità Organizzativa..."
                            onChange={handleParentChange}
                            value={selectedUnit}
                            positionOptions="absolute"
                            zIndex="99999"
                        />
                    </div>
                    <div className="col-span-1 flex items-center ml-10">
                        <button
                            className={`w-28 mt-2 sm:mt-0 inline-flex justify-center align-middle items-center rounded bg-indigo-600 h-6 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${!selectedUnit ? 'invisible' : ''}`}
                            onClick={handleResetUnitSelection}
                            disabled={!selectedUnit}
                        >
                            Reset selezione
                        </button>
                    </div>
                    <div className="hidden md:block md:col-span-1"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 md:ml-8 mx-6 pb-5 gap-y-4 md:gap-y-0 md:gap-x-4 items-center">
                    <div className="col-span-1 flex items-center justify-start md:justify-end md:pr-5">
                    <h1 className="font-medium text-gray-700 uppercase text-sm text-start md:text-end">
                        Seleziona il periodo
                    </h1>
                    </div>
                    <div className="col-span-2 justify-start md:justify-end">
                        <CustomDatePicker 
                            onDateChange={handleDateChange} 
                            valueStart={startDate} 
                            valueEnd={endDate}
                        />
                    </div>
                </div>

                <div className="px-6">
                    <CollapsibleTable 
                        selectedUnitId={selectedUnitId}
                        startDate={startDate}
                        endDate={endDate}
                    />
                </div>
            </main>
            <Footer />
        </div>
    )
};

export default Statistics;
